<div class="m-1 {{ classes() }}" [class.invalid]="isInvalid()" [dir]="languageService.direction()">
    @if (AdaaHelper.isDefinedAndNotEmpty(label())) {
        <label for="{{ effectiveControlId() }}" class="form-label" [dir]="languageService.direction()">
            {{ label() }}
            @if (isRequired() || showAsRequired()) {
                <span class="form-required text-danger fw-bolder">*</span>
            }
        </label>
    }

    <ng-select
        [class.invalid]="isInvalid()"
        [class.bold-label]="boldLabel()"
        [dir]="languageService.direction()"
        [id]="effectiveControlId()"
        [items]="options()"
        [appendTo]="appendTo()"
        bindLabel="text"
        bindValue="value"
        [searchable]="searchable()"
        [clearable]="clearable()"
        [formControl]="inputControl"
        [placeholder]="inputPlaceholder() | translate"
        (search)="searchChannel$.next($event.term)"
        (ngModelChange)="valueChanged($event)"
        (clear)="onClear.emit(null)"
    >
        <ng-template ng-option-tmp let-item="item">
            @if (enableTooltips()) {
                <div class="ng-option-label" [dir]="languageService.direction()" [title]="item.text">{{ item.text }}</div>
            } @else {
                <div class="ng-option-label" [dir]="languageService.direction()">{{ item.text }}</div>
            }
        </ng-template>
    </ng-select>
</div>
